module.exports = __webpack_public_path__ + "img/rules__pieces.61669bc6.png";